<template>
<div>
  <div class="container" v-if="notAnswered">
    <p class="question">{{ questionObject.question }}</p>
    <div class="row">
      <div class="col crop">
        <img :src="questionObject.associatedImage" class="associated-image">
      </div>
    </div>
    <div class="row text-center px-5 mt-4">
      <div :class="columns" v-for="answerObject in questionObject.answers" :key="answerObject.id">
        <button class="btn btn-primary btn-block" @click="answerQuestion(answerObject)">{{ answerObject.answer }}</button>
      </div>
    </div>
  </div>
  <transition name="component-fade" mode="out-in">
    <ResponseMaster :response="response" @next="nextQuestion" v-if="!notAnswered"/>
  </transition>
</div>
</template>

<script>

import ResponseMaster from './ResponseMaster'
  
export default {
  name: 'AssociationQuest',
  components: {
    ResponseMaster
  },
  props: {
    questionObject: {
      type: Object,
      required: true
    }
  },
  data() {
    return { 
      notAnswered: true,
      response: "",
      points: 0
    }
  },
  methods: {
    answerQuestion(answer) {
      this.response    = answer.response
      this.points      = answer.points
      this.notAnswered = false
    },
    nextQuestion() {
      this.notAnswered = true
      this.$emit('answer', this.points)
    }
  },
  computed: {
    columns() {
      if (this.questionObject.answers.length == 3) {
        return 'col-xs-12 col-md-4 mt-1'
      } else {
        return 'col-xs-12 col-md-3 offset-md-2 mt-1'
      }
    }
  }
}
</script>
<style scoped>
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .5s ease;
  }
  .component-fade-enter, .component-fade-leave-to {
    opacity: 0;
  }
  .question {
    color: #000;
    font-size: 1.8rem;
    font-weight: 600;
    margin-bottom: 50px;
  }
  .answers {
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 0 50px;
  }
  .btn-primary {
    background-color: #000000;
    color: rgb(253, 255, 0);
    border: none;
    border-radius: 20px;
    padding: 5px 15px;
    text-align: center;
  }
  .btn-primary:hover,
  .btn-primary:focus {
    background-color: #000000;
    color: rgb(253, 255, 0);
    border: #fff;
  }
  .options-row {
    margin: 30px auto;
  }
  .crop {
    overflow-x: hidden;
  }

  @media (max-width: 576px) { 
    .crop {
      overflow-x: scroll;
    }
  }
  .associated-image {
    max-height: 250px;
  }
</style>
